import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Slider from 'react-slick';
import classNames from 'classnames';
import s from './LinksList.scss';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

class LinksList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      slickInfinite: false,
      slickArrows: false,
    };
  }
  componentDidMount() {
    this.setInfiniteForSlick();
    //if (window) window.addEventListener('resize', this.onWindowResize);
  }
  setInfiniteForSlick = () => {
    try {
      let allItemsWidth = 0;
      const totalWidth = this.slidesContainer
        ? this.slidesContainer.offsetWidth
        : 0;
      const slickSlideNodeList = this.slidesContainer.querySelectorAll(
        '.slick-slide',
      );
      const slickSlideNodeArr = Array.prototype.slice.call(slickSlideNodeList);
      slickSlideNodeArr.forEach(item => {
        allItemsWidth += item.offsetWidth + 15;
      });
      if (allItemsWidth > totalWidth) {
        this.setState({ slickInfinite: true, slickArrows: true });
      } else {
        this.setState({ slickInfinite: false, slickArrows: false });
      }
    } catch (e) {
      // Will catch if there is no item list
    }
  };

  getItemGA = (itemText, index, wu) => {
    const { gaCategory, gaAction } = this.props;
    const gaWithCategoryAction =
      gaCategory && gaAction
        ? // ? `${gaCategory}|${gaAction}_${index}|${itemText}${wu && `_${wu}`}`
          `${gaCategory}|${gaAction}-${index}|${wu && wu}`
        : `TopSection-Actions|Click-TrendingTopics_${itemText}${wu &&
            `_${wu}`}/${index}`;
    return gaWithCategoryAction;
  };
  renderList(
    itemsList,
    ga4Category,
    ga4Type,
    cssSelectorClass,
    sectionData,
    settings,
    hideSliderName,
    label,
    weatherMainPage,
  ) {
    if (itemsList) {
      // console.log('sectionData', sectionData);
      return (
        <InViewObserver
          inViewCallback={() => {
            if (ga4Type) {
              analyticsWrapper('ga4', {
                event: 'user_shown',
                type: `${ga4Type}`,
                category: `${ga4Category || ''}`,
              });
            }
          }}
        >
          <div
            className={`${s.trending} ${cssSelectorClass} ${
              this.props?.articletrendinglist
                ? `articletrendinglistwrapper`
                : ''
            }`}
            id={
              sectionData && sectionData.id === 'keywords' ? sectionData.id : ''
            }
          >
            {!hideSliderName && (
              <h3>
                <span>
                  {sectionData.name || sectionData.title || 'Trending Topics'}
                </span>
              </h3>
            )}
            <div
              ref={el => {
                if (el) {
                  this.slidesContainer = el;
                }
              }}
              className={`${s.trending_list} ${
                this.props?.articletrendinglist ? `articletrendinglist` : ''
              } ${classNames({
                [s.slickinfinite]: this.state.slickInfinite,
                [`trending_list`]: this.state.slickArrows,
              })}`}
            >
              <Slider {...settings}>
                {itemsList &&
                  itemsList.map((item, index) => {
                    const heading =
                      item &&
                      item.hl &&
                      typeof item.hl === 'string' &&
                      item.hl.split('**:').length > 0
                        ? item.hl.split('**:')[0]
                        : item.hl;
                    return (
                      <Link
                        key={item?.id}
                        to={item?.wu}
                        className="keyword"
                        data-ga={`${this.getItemGA(
                          heading,
                          index + 1,
                          item.wu,
                        )}`}
                        target={item.target === '_blank' ? item.target : ''}
                        ga4Data={
                          ga4Type && [
                            {
                              event: 'user_click',
                              type: `${
                                weatherMainPage
                                  ? `${item.hl?.replace(' ', '_')}_click`
                                  : ga4Type
                              }`,
                              label: `${label || heading}`,
                              category: `${ga4Category || 'story_click'}`,
                              story_no: index + 1,
                              msid: item?.id || item?.msid,
                            },
                          ]
                        }
                      >
                        {heading}
                      </Link>
                    );
                  })}
              </Slider>
            </div>
          </div>
        </InViewObserver>
      );
    }
    return null;
  }
  render() {
    const { sectionData } = this.props;
    const {
      items,
      data,
      ga4Category,
      ga4Type,
      label,
      weatherMainPage,
    } = sectionData;
    const itemsList = data && data.length ? data : items;
    const settings = {
      className: 'slider variable-width',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      arrows: this.state.slickArrows,
      infinite: this.state.slickInfinite,
    };

    const { cssSelector, hideSliderName } = this.props;
    const cssSelectorClass = s[cssSelector];
    return this.renderList(
      itemsList,
      ga4Category,
      ga4Type,
      cssSelectorClass,
      sectionData,
      settings,
      hideSliderName,
      label,
      weatherMainPage,
    );
  }
}

LinksList.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  cssSelector: PropTypes.string,
  gaCategory: PropTypes.string,
  gaAction: PropTypes.string,
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
  hideSliderName: PropTypes.bool,
};

LinksList.defaultProps = {
  cssSelector: '',
  gaCategory: '',
  gaAction: '',
  ga4Category: '',
  ga4Type: '',
  hideSliderName: false,
};
export default LinksList;
